var map = {
	"./scene-boss-mr-1-defeat.webp": 7022,
	"./scene-boss-mr-1-opening.webp": 2867,
	"./scene-boss-mr-1-victory.webp": 741,
	"./scene-boss-mr-10-defeat.webp": 7218,
	"./scene-boss-mr-10-opening.webp": 6879,
	"./scene-boss-mr-10-victory.webp": 1105,
	"./scene-boss-mr-2-defeat.webp": 5765,
	"./scene-boss-mr-2-opening.webp": 8906,
	"./scene-boss-mr-2-victory.webp": 7676,
	"./scene-boss-mr-3-defeat.webp": 8916,
	"./scene-boss-mr-3-opening.webp": 1977,
	"./scene-boss-mr-3-victory.webp": 6795,
	"./scene-boss-mr-4-defeat.webp": 9115,
	"./scene-boss-mr-4-opening.webp": 6016,
	"./scene-boss-mr-4-victory.webp": 1442,
	"./scene-boss-mr-5-defeat.webp": 274,
	"./scene-boss-mr-5-opening.webp": 2351,
	"./scene-boss-mr-5-victory.webp": 7361,
	"./scene-boss-mr-6-defeat.webp": 5801,
	"./scene-boss-mr-6-opening.webp": 6262,
	"./scene-boss-mr-6-victory.webp": 1128,
	"./scene-boss-mr-7-defeat.webp": 9176,
	"./scene-boss-mr-7-opening.webp": 4917,
	"./scene-boss-mr-7-victory.webp": 5511,
	"./scene-boss-mr-8-defeat.webp": 9583,
	"./scene-boss-mr-8-opening.webp": 444,
	"./scene-boss-mr-8-victory.webp": 926,
	"./scene-boss-mr-9-defeat.webp": 150,
	"./scene-boss-mr-9-opening.webp": 4507,
	"./scene-boss-mr-9-victory.webp": 1805
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9685;